import { Marquee } from "./marquee.js";
import { gsap } from "gsap";  

const mb = document.querySelectorAll(".mb");
const mbOpen = document.querySelectorAll(".mb-button");

for (let index = 0; index < mbOpen.length; index++) {
  const element = mb[0];
  const elementButton = mbOpen[index];
  elementButton.addEventListener("click", () => {
    element.classList.toggle("active");
    element.classList.toggle("closed");
  });
}

const boxes = gsap.utils.toArray(".super");
const loop1 = new Marquee(boxes, {
  paused: true,
  reversed: false,
  repeat: -1,
  speed: 1.2,
});
loop1.play();
